import React from "react";
import { Info } from "lucide-react";

/**
 * A small ⓘ that explains a term. The note shows on hover and on keyboard
 * focus; screen readers read it as the icon's label.
 */
const InfoHint = ({ text, className = "", align = "left" }) => (
  <span className={`group relative inline-flex align-middle ${className}`}>
    <span
      tabIndex={0}
      role="img"
      aria-label={text}
      className="flex h-4 w-4 cursor-help items-center justify-center rounded-full text-[#9CA3AF] outline-none transition duration-150 hover:text-[#E07A3A] focus-visible:text-[#E07A3A] focus-visible:ring-2 focus-visible:ring-[#E07A3A]/30"
    >
      <Info size={12} />
    </span>
    <span
      role="tooltip"
      aria-hidden="true"
      className={`pointer-events-none invisible absolute top-full z-30 mt-1.5 w-64 rounded-lg bg-[#111827] px-3 py-2 text-[11px] font-normal leading-snug text-white opacity-0 shadow-lg transition duration-150 group-focus-within:visible group-focus-within:opacity-100 group-hover:visible group-hover:opacity-100 ${
        align === "right" ? "right-0" : "left-0"
      }`}
    >
      {text}
    </span>
  </span>
);

export default InfoHint;
